import { useTranslation } from "@/i18n";

interface ProviderOptionProps {
  provider: { id: string; name: string; platform: string; region: string | null };
  selected: boolean;
  label: string;
  description: string;
  onSelect: (id: string) => void;
}

export default function ProviderOption({ provider, selected, label, description, onSelect }: ProviderOptionProps) {
  const { t } = useTranslation();

  // Build provider name display (e.g., "Anthropic", "Google", "OpenAI · Azure")
  const providerNameDisplay = provider.platform === "azure"
    ? `${provider.name} · Azure`
    : provider.name;

  const isGermany = provider.id === "azure-gpt5mini";

  return (
    <button
      type="button"
      onClick={() => onSelect(provider.id)}
      className={`w-full flex items-start gap-3 px-4 py-3 rounded-lg text-left transition-colors cursor-pointer ${
        selected
          ? "bg-[#faf5ff]"
          : "hover:bg-[#fafafa]"
      }`}
    >
      {/* Radio indicator */}
      <div className="mt-0.5 shrink-0">
        <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${
          selected
            ? "border-[#8e2bf0]"
            : "border-[#d4d4d8]"
        }`}>
          {selected && (
            <div className="w-2 h-2 rounded-full bg-[#8e2bf0]" />
          )}
        </div>
      </div>

      {/* Content */}
      <div className="flex-1 min-w-0">
        <div className="text-sm font-medium text-[#18181b]">{label}</div>
        <div className="text-xs text-[#71717a] mt-0.5">{description}</div>
        <div className="text-[11px] text-[#a1a1aa] mt-0.5">{providerNameDisplay}</div>
      </div>

      {/* Badges */}
      <div className="shrink-0 mt-0.5">
        {isGermany && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-medium bg-[#dbeafe] text-[#1e40af]">
            🇩🇪 {t("documentUpload.selection.hostedInDE")}
          </span>
        )}
      </div>
    </button>
  );
}
